import { render, staticRenderFns } from "./SceneListPage.vue?vue&type=template&id=181ec41a&"
import script from "./SceneListPage.vue?vue&type=script&lang=js&"
export * from "./SceneListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports